import { FC } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import tw from 'twin.macro'
import { ImageField } from '@prismicio/client'
import { Body, Grid } from '../UI'
import { RichTextFields } from '../../types/prismic'
import { PrismicRichText } from '@prismicio/react'
import { richTextComponents } from '../../utils/richTextComponents'
import config from '../../../tailwind.config'

type Props = {
  header: string
  subhead: RichTextFields
  image: ImageField
  background_color?: 'gb-blue' | 'gb-red' | 'gb-magenta' | 'gb-cream'
}

const HalfTextHalfImage: FC<Props> = ({
  header,
  subhead,
  image,
  background_color,
}) => {
  console.log(background_color)
  const bgColor = config.theme.extend.colors[background_color]
  const whiteText = background_color !== 'gb-cream'

  return (
    <section
      tw="pb-[68px] lg:(pt-[72px] pb-[55px]) font-domaine overflow-x-hidden"
      css={[
        whiteText ? tw`text-white` : tw`text-gb-blue`,
        { backgroundColor: bgColor },
      ]}
    >
      <Grid tw="mx-0">
        {/* Headline content */}
        <div tw="order-2 col-span-full mx-[30px] pt-[62px] lg:(order-1 col-span-6 mx-0 pt-0)">
          {header && (
            <div tw="col-span-full lg:(col-span-5)">
              <h2 css={[Body, tw`mb-[15px] lg:mb-[25px]`]}>{header}</h2>
            </div>
          )}
          <div tw="col-span-full mb-8 lg:(col-start-1 col-span-4 mb-5 pr-6)">
            <PrismicRichText
              field={subhead.richText}
              components={richTextComponents}
            />
          </div>
        </div>
        <div tw="order-1 col-span-full lg:(order-2 col-start-7 col-span-6 relative)">
          <GatsbyImage
            image={getImage(image)}
            tw="w-full h-[411px] object-cover object-position[50% 50%] lg:(absolute object-position[50% 50%] top-[-72px] h-[calc(100% + 72px + 55px)] left-0 w-[calc(100% + (100vw - 1024px) / 2)] max-w-none mb-0) xl:(w-[calc(100% + (100vw - 1280px) / 2)])"
            alt=""
            objectFit="cover"
            objectPosition="50% 50%"
          />
        </div>
      </Grid>
    </section>
  )
}

export default HalfTextHalfImage
